import { useEffect, useMemo } from "react";
import { applyBrandTokens, resolveBrandId, type ThemeMode } from "@/config/uiTokens";

export function useBrandTokens(mode: ThemeMode) {
  const brandId = useMemo(() => resolveBrandId(), []);

  useEffect(() => {
    applyBrandTokens(brandId, mode);
  }, [brandId, mode]);
}

